 
const schoolName ='';
const schoolId ='';
const limit='';
const devOuttime = 120;
const thirdPartyId = 1;

// $color-menu:#35414f; 
// $color-font:#7bfdd6;
const MColor = '#2e6099';
const FColor = '#7be7fd'; 
const FontColor ='#7bfdd6';
const BackColor ='rgba(75, 168, 255, 0.05)';
 

// const MColor = '#ff9b0b';
// const FColor = '#f11515'; 
// const FontColor ='#f11515';
// const BackColor ='rgba(255, 100, 2, 0.2)';

export default {
 
  schoolName,
  schoolId,
  devOuttime,
  thirdPartyId,
  limit,
  
  MColor,
  FColor,
  BackColor,
  FontColor,
}


// WEBPACK FOOTER //
// ./src/api/global_variable.js